<template>
  <button
      class="btn btn-danger w-100"
      :class="{ 'disabled': isLoading }"
      :disabled="isLoading"
      @click="handleClick"
  >
    <span class="spinner-border spinner-border-sm me-2" v-show="isLoading"></span>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M4 7l16 0"/>
      <path d="M10 11l0 6"/>
      <path d="M14 11l0 6"/>
      <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"/>
      <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"/>
    </svg>
    Удалить
  </button>
</template>

<script setup>
import {defineOptions, ref} from 'vue'
import Api from './Api'

defineOptions({
  name: "WishlistDeleteWishBtn"
})

const props = defineProps({
  wishId: {
    type: Number,
    required: true
  },
})

const emit = defineEmits(['onDelete'])

const isLoading = ref(false)

const handleClick = async () => {
  if (isLoading.value) {
    return
  }

  if (confirm("Вы действительно хотите удалить желание?")) {
    isLoading.value = true
    try {
      const resp = await Api.delete(
          props.wishId,
      )

      let isSuccess = resp?.item ?? null

      if (isSuccess === true) {
        emit('onDelete', {
          success: true,
        })
      } else {
        emit('onDelete', {
          success: false,
        })
      }
    } catch (error) {
      emit('onDelete', {
        success: false,
      })
    } finally {
      isLoading.value = false
    }
  }
}
</script>
